import { Component, OnInit } from '@angular/core';
import * as GLOBAL from 'src/app/shared/globals';
import { Router } from '@angular/router';

@Component({
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

    public uname: String;

    constructor(private router: Router) {

    }

    ngOnInit() { }

    // Hack to scroll back to top when page changes
    public onActivate(event) {
        window.scroll(0, 0);
    }

    public getLoginURL(): String {
        return GLOBAL.authURL + '?returnto=' + GLOBAL.toolURL + this.router.routerState.snapshot.url;
    }

    public isLoggedIn(): Boolean {
        if (sessionStorage.getItem('act_agcl') != null) {
            this.uname = sessionStorage.getItem('uname');
            return true;
        } else {
            return false;
        }
    }

    public logout(): void {
        sessionStorage.clear();
        window.location.href = GLOBAL.authLogoutURL + '?returnto=' + GLOBAL.toolURL;
    }

}
